import React from 'react';
import QuoteForm from './QuoteForm';

const QuoteTeaser = () => {
    return (
        <section className="section" id="quote">
            <div className="container">
                <h2 className="section__title">Get a Free Cleaning Quote</h2>
                <p className="section__subtitle">
                    Tell us about your space — we’ll respond as soon as possible.
                </p>
                <QuoteForm mode="compact" />
            </div>
        </section>
    );
};

export default QuoteTeaser;
